// src/vocabulary/B2/unit1/content.js

const content = {
  level: "B2",
  unit: 1,
  title: "Health & Illness",
  description:
    "Common health problems, symptoms, and advice. Learn how to talk about illness and staying healthy.",

  explanation: [
    "This unit focuses on health, illness, and well-being.",
    "You will learn words to describe symptoms and health problems.",
    "These words are often used when visiting a doctor or giving advice.",
    "In English, people often say how they feel using phrases like 'I have' or 'I feel'.",
    "For example: I have a headache. I feel tired.",
    "You can also give advice using expressions like 'should' or 'need to'.",
    "Health vocabulary is important for everyday life and emergencies.",
    "Try to talk about how you feel and what you do to stay healthy."
  ],

  items: [
    {
      word: "headache",
      phonetic: "/ˈhedeɪk/",
      meaning: "صداع",
      example: "I have a headache."
    },
    {
      word: "fever",
      phonetic: "/ˈfiːvər/",
      meaning: "حمّى",
      example: "She has a high fever."
    },
    {
      word: "cough",
      phonetic: "/kɒf/",
      meaning: "سعال",
      example: "He has a bad cough."
    },
    {
      word: "sick",
      phonetic: "/sɪk/",
      meaning: "مريض",
      example: "I feel sick today."
    },
    {
      word: "doctor",
      phonetic: "/ˈdɒktər/",
      meaning: "طبيب",
      example: "You should see a doctor."
    },
    {
      word: "medicine",
      phonetic: "/ˈmedɪsɪn/",
      meaning: "دواء",
      example: "Take this medicine twice a day."
    },
    {
      word: "healthy",
      phonetic: "/ˈhelθi/",
      meaning: "صحي",
      example: "Eating vegetables keeps you healthy."
    }
  ]
};

export default content;


